import _ from 'lodash';
import WebStoragePolyfill from '../../data-providers/webstorage-polyfill';
import config from 'config';

export default [
  '$q', '$stateParams', '$location', '$window', '$scope',
  'CartService', 'CartAPIService', 'UpsellCartService', 'StateTerritoryData', 'CurrencyService', 'ErrorHandler',
  class PayPalCheckoutCtrl {
    constructor($q, $params, $location, $window, $scope,
      cartService, cartAPIService, upsellCartService, stateTerritoryData, currency, errorHandler) {
      this._$window = $window;
      this._$location = $location;
      this._$scope = $scope;
      this._cartAPI = cartAPIService;
      this._storage = new WebStoragePolyfill();
      this._stateTerritoryData = stateTerritoryData;
      this._username = $params.pn;
      this._campaignSlug = $params.sl;
      this.upsell = $params.upsell === 'true';
      this._errorHandler = errorHandler;

      this._payerID = $location.search().PayerID;
      this._paymentID = $location.search().paymentId;

      this.currency = currency;

      if (!this._payerID || !this._paymentID || !this._username || !this._campaignSlug) {
        this.goBack();
        return;
      }

      $params.pn = null;
      $params.sl = null;
      $location.search('PayerID', null);
      $location.search('paymentId', null);
      $location.search('token', null);
      $location.replace();

      this.isProcessing = true;

      let cartPromise;
      if (this.upsell) {
        let upsellPayload = JSON.parse(this._storage.getLocalItem('paypal-upsell'));
        this._storage.removeLocalItem('paypal-upsell');
        this.cart = upsellCartService;
        cartPromise = this.cart.initPaypal(this._username, this._campaignSlug, [upsellPayload.product], upsellPayload.originalID);
      } else {
        this.cart = cartService;
        cartPromise = this.cart.init(this._username, this._campaignSlug);
      }

      cartPromise
        .then((data) => {
          this.cartTotals = this.cart.getTotals();
          this.campaign = data.campaign;
        })
        .catch(() => this.goBack());

      let paypalPromise = this._cartAPI.paypalPaymentResource(this._paymentID);
      paypalPromise.catch(() => this.goBack());

      let currencyInit = this.currency.init();

      $q.all([cartPromise, paypalPromise, currencyInit])
        .then((res) => {
          // if there is nothing returned from the paypalPromise, then an error has occurred.
          if (Object.keys(res[1]).length) {

            this.shippingAddress = res[1].shipping_address;
            let country = this.shippingAddress.country_code;
            this.currency.setCountry(country);

            this.campaign = res[0].campaign;
            if (country !== 'US') {
              _.each(this.cart.contents(), cartProduct => {
                _.each(this.campaign.products, campaignProduct => {
                  if (cartProduct.cpid === campaignProduct.id) {
                    if (campaignProduct.product.us_only) this.usOnly = true;
                    return false;
                  }
                });
                if (this.usOnly) return false;
              });
            }


            return country === 'US' ? this.cart.setCountry(country, this.shippingAddress.state) : this.cart.setCountry(country);
          } else this.goBack();
        })
        .then(() => this.cartTotals = this.cart.getTotals())
        .finally(() => this.isProcessing = false);
    }

    goBack() {
      let cancel = this._storage.getLocalItem('paypal-cancel');
      if (!cancel) this._$window.history.back();
      else this._$window.location.href = cancel;
    }

    confirm() {
      this.isProcessing = true;

      if (this.upsell) {
        this.placeOrder()
      } else {
        this.cart.validateCouponBeforeCheckout()
          .then(() => this.placeOrder())
          .catch(err => {
            this.showCouponInvalidModal = err && typeof err.valid !== 'undefined';
            this.isProcessing = false;
          });
      }
    }

    placeOrder() {
      this.isProcessing = true;

      this._cartAPI.placePaypalOrder({
          payer_id: this._payerID,
          payment_id: this._paymentID
        })
        .then((res) => {
          this._storage.removeLocalItem('order-credentials');
          this._storage.setLocalItem('order-credentials', `${res.order_num}:${res.zip}`);
          this._$location.search('pn', null);
          this._$location.search('sl', null);
          this._$location.search('upsell', null);
          this._$location.path('/purchase/thank-you').replace();
        })
        .catch(err => {
          this._errorHandler.throwError('PayPal Payment Error', 'An error occurred while attempting to process PayPal order.', { err });
          this.goBack();
        });
    }

    fullCountry() {
      let countries = this._stateTerritoryData.getCountries();
      return _.find(countries, 'code', this.shippingAddress.country_code).country;
    }

    fullState() {
      let states = this._stateTerritoryData.getExtendedStates(),
        provinces = this._stateTerritoryData.getProvinces();

      if (this.shippingAddress.country_code === 'US') {
        let state = _.find(states, 'StateCode', this.shippingAddress.state)
        return state ? state.Name : this.shippingAddress.state;
      }
      if (this.shippingAddress.country_code === 'CA') {
        let province = _.find(provinces, 'StateCode', this.shippingAddress.state);
        return province ? province.Name : this.shippingAddress.state;
      }

      return this.shippingAddress.state;
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/pages/paypal-checkout/paypal-checkout.ctrl.js